import React, { Component } from 'react';

export class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.state = { setting: {}, loading: true };
  }

  componentDidMount() {
    fetch('api/sitesetting')
      .then(r => r.ok ? r.json() : {})
      .then(setting => this.setState({ setting: setting || {}, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    var s = this.state.setting || {};
    var hasMap = s.map_lat && s.map_lng;
    var mapSrc = hasMap ? `https://maps.google.com/maps?q=${encodeURIComponent(s.map_lat)},${encodeURIComponent(s.map_lng)}&z=${s.map_zoom || 15}&output=embed` : '';

    return (
      <div style={{ background: '#fafafa' }}>
        {/* Hero */}
        <div style={{ background: 'linear-gradient(135deg,#c82333 0%,#9d1a26 100%)', color: '#fff', padding: '60px 20px 80px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.08), transparent 50%)' }}></div>
          <div style={{ position: 'relative', maxWidth: 900, margin: '0 auto' }}>
            <div style={{ fontSize: 13, letterSpacing: 3, opacity: 0.9, fontWeight: 600, marginBottom: 10 }}>ABOUT US</div>
            <h1 style={{ fontSize: 44, fontWeight: 900, margin: 0, lineHeight: 1.2 }}>
              {s.about_title || 'เกี่ยวกับเรา'}
            </h1>
            {s.about_subtitle && (
              <div style={{ fontSize: 18, marginTop: 14, opacity: 0.95, lineHeight: 1.6 }}>{s.about_subtitle}</div>
            )}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: '50px auto 40px', padding: '0 20px' }}>
          {/* Content card */}
          <div style={{ background: '#fff', borderRadius: 16, padding: '40px 40px 48px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', marginBottom: 30 }}>
            <div className="row align-items-start g-4">
              {s.about_image && (
                <div className="col-lg-5">
                  <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' }}>
                    <img src={s.about_image} alt="" style={{ width: '100%', display: 'block' }} />
                  </div>
                </div>
              )}
              <div className={s.about_image ? 'col-lg-7' : 'col-12'}>
                {s.about_content ? (
                  <div style={{ fontSize: 16, color: '#444', lineHeight: 1.85 }} dangerouslySetInnerHTML={{ __html: s.about_content }}></div>
                ) : !this.state.loading && (
                  <div style={{ fontSize: 16, color: '#444', lineHeight: 1.85 }}>
                    <p>บริษัทแอนท์ เจอร์นีย์ เฮาส์ จำกัด ประกอบธุรกิจท่องเที่ยว มีวัตถุประสงค์ในการจัดการและบริการการท่องเที่ยวทั้งในประเทศและต่างประเทศ เพื่อตอบสนองความต้องการของลูกค้ามากที่สุด</p>
                    <p>แอนท์ เจอร์นีย์ เฮาส์ จำกัด ได้รวบรวมบุคลากรที่มีศักย์ภาพและประสบการณ์ในการทำธรุกิจการท่องเที่ยว พร้อมให้คำปรึกษา จัดการปัญหาเพื่อสร้างความเชื่อมั่นให้กับลูกค้า</p>
                    <p>ทางบริษัท "เรา" ยินดีที่จะให้บริการลูกค้าอย่างเต็มที่ เพื่อสร้างประสบการณ์และความประทับใจในการท่องเที่ยว ให้ตอบสนองความต้องของลูกค้าอย่างมากที่สุด</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Contact strip */}
          <div className="row g-3 mb-4">
            {s.phone && (
              <div className="col-md-4">
                <a href={'tel:' + s.phone} style={{ display: 'block', background: '#fff', borderRadius: 12, padding: 20, textDecoration: 'none', color: '#333', boxShadow: '0 4px 16px rgba(0,0,0,0.06)', transition: 'transform 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-phone-alt"></i></div>
                    <div>
                      <div style={{ fontSize: 12, color: '#888' }}>โทรศัพท์</div>
                      <div style={{ fontSize: 16, fontWeight: 700 }}>{s.phone}</div>
                    </div>
                  </div>
                </a>
              </div>
            )}
            {s.email && (
              <div className="col-md-4">
                <a href={'mailto:' + s.email} style={{ display: 'block', background: '#fff', borderRadius: 12, padding: 20, textDecoration: 'none', color: '#333', boxShadow: '0 4px 16px rgba(0,0,0,0.06)', transition: 'transform 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-envelope"></i></div>
                    <div>
                      <div style={{ fontSize: 12, color: '#888' }}>อีเมล</div>
                      <div style={{ fontSize: 15, fontWeight: 700 }}>{s.email}</div>
                    </div>
                  </div>
                </a>
              </div>
            )}
            {s.address && (
              <div className="col-md-4">
                <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                    <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><i className="fas fa-map-marker-alt"></i></div>
                    <div>
                      <div style={{ fontSize: 12, color: '#888' }}>ที่อยู่</div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#333', lineHeight: 1.5, whiteSpace: 'pre-line' }}>{s.address}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Map */}
          {hasMap && (
            <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,0.08)' }}>
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
                <div style={{ fontWeight: 800, fontSize: 16, color: '#333' }}><i className="fas fa-map-marked-alt" style={{ color: '#dc3545' }}></i> ที่ตั้ง</div>
                <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(s.map_lat)},${encodeURIComponent(s.map_lng)}`} target="_blank" rel="noopener noreferrer" className="btn btn-danger btn-sm">
                  <i className="fas fa-directions"></i> นำทาง
                </a>
              </div>
              <iframe title="location" width="100%" height="450" frameBorder="0" style={{ border: 0, display: 'block' }} src={mapSrc} loading="lazy"></iframe>
            </div>
          )}
        </div>
      </div>
    );
  }
}
